import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReportsActions } from "store/ducks/reports";

import { Access, NumberFormat } from "common";
import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters } from "./components";

const INITIAL_STATE = {
  region: null,
  date_start: null,
  date_end: null,
  plan: { value: 0, label: "MEMBROS CADASTRADOS" },
  date_formatted: "",
  stores_formatted: "Todas",
};

class RegisterRanking extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Ranking de cadastros", to: "" },
    ],
    filter: {
      ...INITIAL_STATE,
      stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
    },
  };

  componentDidMount() {
    const { getReportRegisterRankingRequest } = this.props;

    getReportRegisterRankingRequest(this.state.filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.stores !== filter.stores) {
      const stores_formatted = filter.stores
        .map((store) => store.label)
        .join(", ");

      this.setState({ filter: { ...filter, stores_formatted } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getReportRegisterRankingRequest } = this.props;

    const newState = { filter: { ...filter, [name]: value } };

    if (name === "region" && !filter.stores.length) {
      return this.setState(newState);
    }

    if (name === "region") {
      newState.filter.stores = [];
      newState.filter.stores_formatted = "Todas";
    }

    this.setState(newState, () => {
      getReportRegisterRankingRequest(this.state.filter);
    });
  };

  handleCleanFilter = async (e) => {
    e.preventDefault();

    const { getReportRegisterRankingRequest } = this.props;

    const newState = {
      filter: {
        ...INITIAL_STATE,
        stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
      },
    };

    this.setState(newState, () => {
      getReportRegisterRankingRequest(this.state.filter);
    });
  };

  handleExport = () => {
    const { filter } = this.state;
    const { exportReportRegisterRankingRequest } = this.props;

    exportReportRegisterRankingRequest(filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { reports } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Ranking de cadastros</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
          />
        </header>

        <Panel className="panel-list">
          {!reports.data.length && reports.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {reports.loading && <Loading type="table" size="x-large" />}

              {filter.date_formatted !== "" && (
                <Panel.Title>
                  Período: <span>{filter.date_formatted}</span>
                </Panel.Title>
              )}

              {filter.stores_formatted !== "" && (
                <Panel.Title>
                  Lojas: <span>{filter.stores_formatted}</span>
                </Panel.Title>
              )}

              <h5>Ranking de cadastros</h5>

              <table className="contact-table table table-curved">
                <tbody>
                  {!!reports.data.length &&
                    reports.data.map((report, index) => (
                      <tr key={`${report.store_id}-${index}`}>
                        <td>
                          {report.position} - {report.store_name}
                        </td>
                        <td className="number-report">
                          {NumberFormat(report.full_quantity, 0, ",", ".")}
                        </td>
                      </tr>
                    ))}
                  <tr>
                    <td>
                      <b>TOTAL</b>
                    </td>
                    <td className="number-report">
                      <b>{NumberFormat(reports.total, 0, ",", ".")}</b>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button className="button-submit" onClick={this.handleExport}>
                Exportar Planilha
              </button>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  reports: {
    ...state.reports.registerRanking,
    data: state.reports.registerRanking.data,
    total: state.reports.registerRanking.total,
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(RegisterRanking);
